import { Grid, Typography, makeStyles, Box } from '@material-ui/core';
import BottomSheet from 'components/BottomSheet/BottomSheet';
import { InfoCircle } from 'iconsax-react';
import ContentInfo from './ContentInfo';

const useStyle = makeStyles(() => ({
	title: {
		fontSize: '14px',
		fontWeight: 500,
		color: '#888BA0',
	},
	subTitle: {
		fontSize: '14px',
		fontWeight: 700,
		color: '#101740',
	},
	overdue: {
		padding: '0 10px',
		backgroundColor: '#FFF1F0',
		marginTop: '16px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderRadius: '4px',
		'&:hover': {
			cursor: 'pointer',
		},
	},
}));
const AmountInstallments = ({hasOverDue}) => {
	const classes = useStyle();

	const handleClick = () => {
		// eslint-disable-next-line no-console
		console.log('click');
	};

	return (
		<Grid container>
			<Grid item xs={12} display={'flex'} justifyContent={'space-between'}>
				<Grid container>
					<Grid item xs={6}>
						<Typography className={classes.title}>بازه دوره:</Typography>
						<Typography
							style={{
								fontSize: '12px',
								fontWeight: 500,
								color: '#101740',
								display: 'flex',
								marginTop: '4px',
							}}
						>
							<Typography className={classes.subTitle} style={{ marginLeft: '4px' }}>
								16 اسفند
							</Typography>
							الی
							<Typography className={classes.subTitle} style={{ marginRight: '4px' }}>
								15 فروردین
							</Typography>
						</Typography>
					</Grid>
					<Grid item xs={6} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
						<Typography className={classes.title}>مجموع مبلغ اقساط:</Typography>
						<Typography
							style={{
								fontSize: '12px',
								fontWeight: 500,
								color: '#101740',
								display: 'flex',
								marginTop: '4px',
							}}
						>
							<Typography className={classes.subTitle} style={{ marginLeft: '4px' }}>
								2,625,000{' '}
							</Typography>
							تومان
						</Typography>
					</Grid>
				</Grid>
				{hasOverDue && (
				<BottomSheet
					style={{ width: '100%', padding: 0, margin: 0 }}
					Component={
						<Box width={'100%'} p={'24px'}>
							<ContentInfo />
						</Box>
					}
					button={
						<Grid container>
							<Grid item xs={12} className={classes.overdue} onClick={handleClick}>
								<Grid container>
									<Grid item xs={7} style={{ display: 'flex', justifyContent: 'flex-start' }}>
										<Typography
											style={{
												fontSize: '12px',
												fontWeight: 500,
												color: '#FF6B72',
												display: 'flex',
												alignItems: 'center',
											}}
										>
											مجموع مبلغ اقساط معوق شده:
											<InfoCircle size="15" color="#FF6B72" style={{ marginRight: '4px' }} />
										</Typography>
									</Grid>
									<Grid item xs={5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
										<Typography
											style={{
												fontSize: '18px',
												fontWeight: 700,
												color: '#FF6B72',
												display: 'flex',
												alignItems: 'center',
											}}
										>
											3,500,000
											<Typography
												style={{ fontSize: '12px', fontWeight: 500, color: '#FF6B72', marginRight: '4px' }}
											>
												تومان
											</Typography>
										</Typography>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					}
				/>

				)} 
			</Grid>
		</Grid>
	);
};

export default AmountInstallments;
